// UpdateBranch.jsx
import React, { useContext, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { toast } from "react-toastify";
import { UserContext } from "../../../Context/UserContext.js";
import { CompanyContext } from "../../../Context/CompanyContext.js";
import { BranchContext } from "../../../Context/BranchContext.js";


   export default function UpdateBranch() {
      const {userToken } = useContext(UserContext) ;
      const {allCompanyInfo , getAllCompanyInfo } = useContext(CompanyContext) ;
      const {getSpecificBranch , branch } = useContext(BranchContext) ;
      const closeBtnRef = useRef() ;


      const header = {
         token:`${process.env.REACT_APP_BEARER_TOKEN} ${userToken || localStorage.getItem("token")}`
      }


      const handleSubmit = async(values, { resetForm }) => {
         await axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/branch/${branch._id}` , values , {headers:header})
         .then(({data})=>{
            if(data.message === "success"){
               toast.success("Updated Branch Successfully ")
               getSpecificBranch(branch._id)
            }
         })
         .catch((error)=>{
            toast.error(error.response.data.message)
         })
         resetForm();
         closeBtnRef.current.click() ;
      };


      const initialValues = {
         name:branch.name || "",
         email:branch.email || "",
         phone:branch.phone || "",
         company:branch.company?._id || "",
         street:branch.address?.street || "",
         city:branch.address?.city || "",
         area:branch.address?.area || "",
         isActive:branch.isActive !== undefined ? branch.isActive.toString() : "",
      } ;
      const validationSchema = Yup.object({
         name:Yup.string().min(2 , "Name Should be More than 2").max(50 , "Name less than 50").required("Name is Required").trim() ,
         email:Yup.string().email().required().trim() ,
         phone:Yup.string().required().matches(/^01[0125][0-9]{8}$/).trim() ,
         company:Yup.string().matches(/^[0-9a-fA-F]{24}$/, 'Invalid ID format').required('ID is required') ,
         street:Yup.string().required().trim() ,
         city:Yup.string().required().trim() ,
         area:Yup.string().required().trim() ,
         isActive:Yup.string()
      });


      useEffect(() => {
         getAllCompanyInfo();
      }, [])
      return (
            <div className="updateBranch-container">
               <div className="modal fade" id="UpdateBranch" tabIndex="-1" aria-labelledby="UpdateBranchLabel" aria-hidden="true">
                  <div className="modal-dialog modal-xl">
                     <div className="modal-content">

                        <div className="modal-header">
                           <h5 className="modal-title" id="UpdateBranchLabel">تعديل بيانات الفرع</h5>
                           <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeBtnRef}></button>
                        </div>

                        <div className="modal-body">
                           <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit} enableReinitialize >
                              <Form>
                                 <div className="mb-3">
                                    <label className="form-label">أسم الفرع</label>
                                    <Field type="text" name="name" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="name" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">أيميل الفرع</label>
                                    <Field type="email" name="email" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="email" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">موبايل الفرع</label>
                                    <Field type="tel" name="phone" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="phone" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">الشركة التابع لها الفرع</label>
                                    <Field as="select" name="company" className="form-select">
                                       <option value="">اختر الشركة</option>
                                       {allCompanyInfo.length > 0 ? 
                                          allCompanyInfo.map((company)=><option value={company._id}>{company.name}</option>): ""}
                                    </Field>
                                    <div className="text-danger"><ErrorMessage name="company" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">الشارع</label>
                                    <Field type="text" name="street" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="street" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">المدينة</label>
                                    <Field type="text" name="city" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="city" /></div>
                                 </div>

                                 <div className="mb-3">
                                    <label className="form-label">المنطقة</label>
                                    <Field type="text" name="area" className="form-control" />
                                    <div className="text-danger"><ErrorMessage name="area" /></div>
                                 </div>


                                 <div className="mb-3">
                                    <label className="form-label d-block">الحالة</label>

                                    <div className="form-check form-check-inline">
                                       <Field
                                          type="radio"
                                          name="isActive"
                                          value="true"
                                          className="form-check-input"
                                          id="activeTrue"
                                       />
                                       <label htmlFor="activeTrue" className="form-check-label">مُفعل</label>
                                    </div>

                                    <div className="form-check form-check-inline">
                                       <Field
                                          type="radio"
                                          name="isActive"
                                          value="false"
                                          className="form-check-input"
                                          id="activeFalse"
                                       />
                                       <label htmlFor="activeFalse" className="form-check-label">غير مُفعل</label>
                                    </div>

                                    <div className="text-danger"><ErrorMessage name="isActive" /></div>
                                 </div>

                                 <div className="d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary">تغيير</button>
                                 </div>
                              </Form>
                           </Formik>
                        </div>

                     </div>
                  </div>
               </div>
            </div>
         );
   }
